'use strict';

angular
	.module('rmTemplate', []);

require('./controller');
require('./resources');
require('./directives');
require('./routes');
